import { Dispatch } from "redux";
import { ApiConfig } from '../../../../config'
import { AppStateWithData } from "../../../AppStateWithData";
import { processTasksResponse } from "./processTasksResponse";
import { Task } from "../../../../models"
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk";
import { fetchFeedTasksActionTypes } from "../tasksTypes";

export interface TasksResults {
    tasks: Task[],
    total: number
}

export const getFeedTasks = (config: ApiConfig) => (page: number) => async (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<TasksResults> = {
        method: 'GET',
        requestActionTypes: fetchFeedTasksActionTypes,
        processResultBeforeDispatch: processTasksResponse(dispatch),
        url: `${config.API_URL}/tasks/feedTasks/?page=${page}`,
    }

    dispatch<any>(createRequestThunk(thunkParams))
}